import { useState, useEffect } from 'react'
import type { ChatStatusMessageItemState } from './types/ChatStatusMessageTypes'

export const PHRASE_INTERVAL_MS = 3600

// State-machine hook for cycling loading phrases.
// While state='loading' it advances through phrases on a timer.
// When state transitions to 'done' the timer stops and returns null
// so the caller falls back to the final message.
const useChatStatusPhases = (
    state: ChatStatusMessageItemState,
    loadingPhrases: string[]
): string | null => {
    const [index, setIndex] = useState(0)

    useEffect(() => {
        if (state !== 'loading' || loadingPhrases.length < 2) {
            setIndex(0)
            return
        }
        const timer = setInterval(() => {
            setIndex(i => (i + 1) % loadingPhrases.length)
        }, PHRASE_INTERVAL_MS)
        return () => clearInterval(timer)
    }, [state, loadingPhrases.length])

    if (state !== 'loading' || !loadingPhrases.length) return null
    return loadingPhrases[index]
}

export default useChatStatusPhases
